module.exports = __webpack_public_path__ + "img/fail.6719994c.png";